import styled from "styled-components/macro";
import { Box, Stack } from "@mui/material";

export const EquipmentListWrapper = styled(Box)`
    //TODO: need to remove height. Only used for development
    /* height: 99vh;
    overflow: auto; */
    padding: 15px;
    > section {
        width: 100%;
        border: 1px solid lightgray;
        margin: 13px auto;
        border-radius: 8px;
        box-shadow: 0px 0px 10px 0px #e1e1e1;
        > article {
            border: none;
            header {
                padding: 15px 20px;
                p {
                    font-family: Verdana;
                    font-size: 14px;
                    color: #323232;
                }
            }
        }
    }
    > section:last-child {
        margin-bottom: 0;
        > article {
            header {
             padding: 0px 20px;
                p {
                    width: 95%;
                }
                > div {
                    padding-bottom: 0;
                }
            }
            > div {
                padding: 0px 20px 14px;
            }
        }
    }
`;

export const SelectBoxContainer = styled(Box)`
    width: 250px;
    #select-label-building, #select-label-familyType{
        color: #323232;
    }
    #select-building, #select-familyType {
        padding: 8px 8px;
        > div {
            img {
                margin-left: 4px;
            }
        }
    }
`;

export const TableWrapper = styled(Box)`
    position: relative;
    > div {
        border: 1px solid #e2e2e2;
        border-radius: 8px;
        height: 350px; // TODO: need to remove this height in future
        overflow-x: auto;
        max-height: ${(props) => (props.maxTableHeight ? props.maxTableHeight : "none")};
        /* margin-bottom: 12px; */
        > div {
            display: none;
        }
    }
    table {
        border-collapse: separate;
        border-radius: 8px;
        border: none;
        thead {
            position: sticky;
            top: 0px;
            background: #fff;
            z-index: 100;
            tr {
                th {
                    font-family: Verdana; 
                    font-size: 13px;
                    font-weight: bold;
                    text-align: left !important;
                    border-radius: 8px 8px 0 0;
                    position: relative;
                    padding: 17px 0px;
                    user-select: none;
                    max-width: 300px;
                    min-width: 220px;
                    padding-right: 35px;
                    > div {
                        margin-left: 5px;
                        margin-top: -4px;
                        right: 32px;
                        top: calc(50% - 13px);
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    font-family: Verdana;
                    font-size: 12px;
                    text-align: left !important;
                    padding: 13px;
                }
            }
        }
    }
`;

export const NoRecordsDiv = styled(Box)`
    border: none !important;
    position: absolute;
    top: 50%;
    left: 46%;
`;

export const DataViewHeader = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    > label {
        margin: 0;
    }
`;

export const ViewModeSelect = styled(Box)`
    margin: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    div#select-viewMode {
        padding: 5px;
        width: 130px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
         > div {
            margin: 0;
            margin-left: 3px;
            svg {
                font-size: 20px;
                color: #323232;
            }
            p {
                font-size: 13px;
                color: #323232;
            }
         }
    }
`;

export const ChartContainer = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
`;

export const MenuListWrapper = styled(Box)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-left: -6px;
    p {
        font-size: 13px;
        color: #323232;
    }
    svg {
        font-size: 18px;
        margin-right: 8px;
        color: #323232;
    }
`;

export const DataPointLoader = styled.div`
    .spinner {
        width: 100px;
        text-align: center;
        padding-top: 5px;
    }

    .spinner > span {
        width: 16px;
        height: 16px;
        background-color: gray;
        border-radius: 50%;
        display: inline-block;
        animation: pulse 1.1s infinite ease-in-out;
        animation-fill-mode:both;		
    }

    .spinner .bubble1 {
        animation-delay: 0s;
    }

    .spinner .bubble2 {
        animation-delay: 0.15s
    }

    .spinner .bubble3 {
        animation-delay: 0.3s
    }

    @keyframes pulse {
        0%, 80%, 100% { transform: scale(0.5); opacity:0.2; }
        40% { transform: scale(0.8); opacity:1; }
    }
`;

export const PointSelect = styled(Box)`
    width: 250px;

    #select-label-point {
        color: #323232;
    }
    #select-point {
        color: #323232;
        padding: 8px 8px;
        font-size: 13px;
    }
`;

export const PointSelectNarrow = styled(Box)`
    width: 150px;

    #select-label-periods {
        color: #323232;
    }
    #select-periods {
        padding: 8px 8px;
        font-size: 13px;
        color: #323232;
    }
`;


export const LineChartContainer = styled(Box)`
    width: 100%;
`;

export const LineChartButtons= styled(Box)`
    display: flex;
    column-gap: 10px;
    margin-bottom: 20px;
    > label {
        margin: 0;
    }
`;

export const MultiSelectWrapper = styled(Stack)`
    .multi-select-wrapper {
        width: 42%;
        > p {
            color: #323232;
            margin-bottom: 8px;
        }
    }
    .rmsc.multi-select {
        width: 100%;
        .dropdown-container {
            border: 1px solid #babfc7 !important;
            border-radius: 5px !important;
            height: 35px;
            .dropdown-heading {
                height: inherit;
                cursor: pointer;
                .dropdown-heading-value {
                    padding-bottom: 3px;
                    span {
                        font-size: 1.1rem;
                        color: #4e4e4e;
                    }
                }
            }
            .dropdown-content {
                background: #fff !important;
                border-radius: 5px;
                border: 1px solid #babfc7 !important;
                .panel-content {
                    border-radius: 5px;
                    .select-panel {
                        .search {
                            background: #fff !important;
                            border: 1px solid #babfc7!important;
                            border-radius: 5px 5px 0 0;
                            input {
                                border-radius: 5px !important;
                                height: 28px !important;
                                font-size: 13px;
                                color: #585858;
                            }
                            svg {
                                padding-top: 3px;
                                padding-right: 5px;
                                font-size: 20px;
                            }
                        }
                        .options {
                            > label > div > span {
                                color: #0066d3 !important;
                            }
                        }
                        .select-item {
                            font-size: 13px;
                            .item-renderer {
                                span {
                                    margin-left: 3px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;